import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {ColorConfig, ColorConfigJson} from './color-config';
import {BorderConfig, BorderConfigJson} from './border-config';

export type InfusionConfigJson =  {
  border: BorderConfigJson;
  color: ColorConfigJson;
};

export class InfusionConfig implements JsonConfigInterface<InfusionConfigJson> {

  public readonly border: BorderConfig = new BorderConfig();
  public readonly color: ColorConfig = new ColorConfig();

  constructor(json?: InfusionConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public deserializeJson(json: InfusionConfigJson): void {
    this.border.deserializeJson(json.border);
    this.color.deserializeJson(json.color);
  }
}
